/**
 * @fileoverview GET handler for the "/engagement/email_templates/territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesTerritories } from "./constants";
import type { EngagementEmailTemplatesTerritoriesResult } from "./types";

export const getEngagementEmailTemplatesTerritories = reactQueryFetcherAdapter(
  engagementEmailTemplatesTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementEmailTemplatesTerritoriesResult> => {
    return fetch("/engagement/email_templates/territories", "GET", { app_group_id: appGroupId }, { signal });
  }
);
